import { render, staticRenderFns } from "./parkgroup.vue?vue&type=template&id=542d6f07&"
import script from "./parkgroup.vue?vue&type=script&lang=js&"
export * from "./parkgroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports